<template>
  <div class="whatsapp-configuracoes">
    <v-container class="py-0 px-0" fluid>
      <v-row>
        <v-col class="py-0">
          <v-row>
            <v-col>
              <multiple-numbers />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <offline-number-tip />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="py-0">
          <v-row>
            <v-col>
              <mensagem-boas-vindas-card />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <mensagem-resposta-optout-card />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <mensagem-resposta-automatica-card />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <mensagem-optout-card />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    MultipleNumbers: () => import('@/modules/campanhas/whatsapp/views/components/ConfiguracoesMultipleNumbers.vue'),
    OfflineNumberTip: () => import('@/modules/campanhas/whatsapp/views/components/OfflineNumberTip.vue'),
    MensagemBoasVindasCard: () => import('@/modules/campanhas/whatsapp/views/components/ConfiguracoesMensagemBoasVindas.vue'),
    MensagemOptoutCard: () => import('@/modules/campanhas/whatsapp/views/components/ConfiguracoesMensagemOptout.vue'),
    MensagemRespostaOptoutCard: () => import('@/modules/campanhas/whatsapp/views/components/ConfiguracoesMensagemRespostaOptout.vue'),
    MensagemRespostaAutomaticaCard: () => import('@/modules/campanhas/whatsapp/views/components/ConfiguracoesMensagemRespostaAutomatica.vue'),
  },
}
</script>

<style lang="scss">
.whatsapp-configuracoes {
  .whatsapp-title {
    color: $cinza-d20;
    letter-spacing: 0.33px;
    font-size: 18px;
    font-weight: bold;
  }

  .card-body {
    height: calc(100% - 70px);
  }

  .table-body {
    height: calc(100% - 50px);
    overflow: auto;
  }

  .seus-numeros-label {
    font-size: 14px;
    letter-spacing: 0.27px;
    color: $cinza-d20;
  }
  .v-card__title {
    padding-bottom: 0px;
  }
}
</style>
